import React, { useCallback, useMemo } from 'react'
import { IMasterCurricula } from 'infrastructure/api'
import { Box, Button } from '@mui/material'
import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import {
  curriculaMapAtom,
  masterTreeIdAtom,
  useSortedMastersWithErrorNotification,
} from './atoms'
import { Table } from 'shared/ui/Table/Table'
import { allProductsById } from '../../../api/masters.atoms'

export function Versions({ productId }: { productId: number }) {
  const product = useAtomValue(allProductsById)[productId]
  useSetAtom(masterTreeIdAtom)(product?.primary_tree_tree_id ?? '')
  const refresh = useSetAtom(curriculaMapAtom)
  const versions = useSortedMastersWithErrorNotification() ?? []
  const columns = useTableColumns()

  return (
    <Box>
      <strong>Versions</strong>
      <Button onClick={refresh}>R</Button>
      <Table columns={columns} items={versions} />
    </Box>
  )
}

function useTableColumns() {
  const getCount = useCurriculaCount()
  return useMemo(() => {
    return [
      {
        title: <strong>Version</strong>,
        width: 50,
        rowContent(curr: IMasterCurricula) {
          return curr.name
        },
      },
      {
        title: <strong>School Count</strong>,
        width: 50,
        rowContent(curr: IMasterCurricula) {
          return getCount(curr)?.school.length || ''
        },
      },
      {
        title: <strong>District Count</strong>,
        width: 50,
        rowContent(curr: IMasterCurricula) {
          return getCount(curr)?.district.length || ''
        },
      },
      {
        title: <strong>Created</strong>,
        width: 50,
        rowContent(curr: IMasterCurricula) {
          return curr.createdAt.split('T')[0]
        },
      },
      {
        title: <strong>IDs</strong>,
        width: 50,
        rowContent(curr: IMasterCurricula) {
          return (
            <Button
              onClick={() =>
                navigator.clipboard.writeText(`${curr.treeId}:${curr.version}`)
              }
            >
              Copy
            </Button>
          )
        },
      },
    ]
  }, [getCount])
}

function useCurriculaCount() {
  const curriculaMap = useAtomValue(curriculaMapAtom)
  return useCallback(
    (m: IMasterCurricula) => {
      if (!curriculaMap) return
      return curriculaMap[`${m.treeId}:${m.version}`]
    },
    [curriculaMap],
  )
}
